import { render, staticRenderFns } from "./AdminConfigurePipelineIdsPage.vue?vue&type=template&id=b3f24f32"
import script from "./AdminConfigurePipelineIdsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminConfigurePipelineIdsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports